import { Box } from "@mui/material";
import MultimediaSection from "./MultimediaSection";
import { updateStateObjectData } from "../../../utility/Common";
import { useRef, useState } from "react";
import MediaPreviewDialog from "../../Questions/MediaPreviewDialog";
import { useLocation, useNavigate } from "react-router-dom";
import MediaUploadDialog from "./MediaUploadDialog";

export const MultimediaPanelView = ({ editableEntityData, setEditableEntityData, global_constant, getMultiMediaByEntityId, editableEntityMultimediaData, artists }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [mediaPreview, setMediaPreview] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    console.log("editableEntityMultimediaData : ",editableEntityMultimediaData);
    const multimedia = Array.isArray(editableEntityMultimediaData) ? editableEntityMultimediaData : [];

    const images = multimedia?.filter((m) => m.form === "image");
    const thumbnails = multimedia.filter((m) => m.form === "image" && m.type === "thumbnail");
    const avatars = multimedia.filter((m) => m.form === "image" && m.type === "avatar");
    const banners = multimedia.filter((m) => m.form === "image" && m.type === "banner");
    const otherImages = multimedia.filter((m) => m.form === "image" && !["thumbnail", "avatar", "banner"].includes(m.type));

    const videos = multimedia?.filter((m) => m.form === "video");
    const audios = multimedia?.filter((m) => m.form === "audio");

    console.log("images : ",images);
    console.log("videos : ",videos);
    console.log("audios : ",audios);

    const navigateToCreateOrUpdateMultimedia = (_entity_data, index, selectedItem) => {
        console.log("navigateToCreateOrUpdateMultimedia : ", _entity_data, index, selectedItem);
        navigate('/entertainment-entity-management/create-entertainment-entity/create-multimedia-entity', {
            state: {
                entity_data: _entity_data,
                index: index,
                multimedia: selectedItem,
                entertainment_entity_filter: global_constant,
                artists:artists,
                from: 'CreateEntertainmentEntity'
            }
        });
    };

    console.log("global_constant : ",global_constant);
    return (
        <>
            <Box>
                <MultimediaSection
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    title="Image"
                    mediaType="image"
                    data={images}
                    ratioOptions={global_constant.multimedia_ratio}
                    onAdd={() => {
                        console.log("Add image1")
                        //handleFileChange(event,"image");
                    }}
                    onDelete={(idx, item, mediaType) => {
                        console.log("Add image2")
                        const updated = multimedia?.filter((media) => media.url !== item.url);
                        updateStateObjectData(editableEntityData, setEditableEntityData, 'multimedia', updated);
                    }}
                    onItemClick={(idx, item, mediaType) => {
                        console.log("Add image3")
                        console.log("Add idx : ",idx)
                        console.log("Add item : ",item)
                        console.log("Add mediaType : ",mediaType)
                        console.log("Add editableEntityData : ",editableEntityData)
                        //setSelectedItem(item);
                        //setMediaPreview(true);
                        navigateToCreateOrUpdateMultimedia(editableEntityData, idx, item);
                    }}
                    getMultiMediaByEntityId={getMultiMediaByEntityId}
                    editableEntityMultimediaData={editableEntityMultimediaData}
                />

                <MultimediaSection
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    title="Video"
                    mediaType="video"
                    data={videos}
                    ratioOptions={global_constant.multimedia_ratio}
                    onAdd={() => {
                        console.log("Add video")
                        //handleFileChange(event,"video");
                    }}
                    onDelete={(idx, item, mediaType) => {
                        const updated = multimedia?.filter((media) => media.url !== item.url);
                        updateStateObjectData(editableEntityData, setEditableEntityData, 'multimedia', updated);
                    }}
                    onItemClick={(idx, item, mediaType) => {
                        setSelectedItem(item);
                        //setMediaPreview(true);
                        navigateToCreateOrUpdateMultimedia(editableEntityData, idx, item);
                    }}
                    getMultiMediaByEntityId={getMultiMediaByEntityId}
                    editableEntityMultimediaData={editableEntityMultimediaData}
                />

                <MultimediaSection
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    title="Audio"
                    mediaType="audio"
                    data={audios}
                    onAdd={() => {
                        console.log("Add audio")
                        //handleFileChange(event,"audio");
                    }}
                    onDelete={(idx, item, mediaType) => {
                        const updated = multimedia?.filter((media) => media.url !== item.url);
                        updateStateObjectData(editableEntityData, setEditableEntityData, 'multimedia', updated);
                    }}
                    onItemClick={(idx, item, mediaType) => {
                        setSelectedItem(item);
                        //setMediaPreview(true);
                        navigateToCreateOrUpdateMultimedia(editableEntityData, idx, item);
                    }}
                    getMultiMediaByEntityId={getMultiMediaByEntityId}
                    editableEntityMultimediaData={editableEntityMultimediaData}
                />
            </Box>

            <MediaPreviewDialog
                open={mediaPreview}
                onClose={() => setMediaPreview(false)}
                multimedia={selectedItem}
            />

        </>
    );
};